module.exports = __webpack_public_path__ + "static/media/discover.6fdf8ba8.svg";